import React, { useState, useEffect } from 'react';
import ChatBot from './Chatbot/ChatBot';
import ImageSelection from './ImageSelection';
import './ComponenteInferior.css';
import PreviewScreen from './PreviewScreen';
import Calendario from './Calendario/Calendario';
import { useHistory } from 'react-router-dom';
import PublishSelection from './PublishSelection';
import SchedulePost from './SchedulePost';
import arrowSVG from './Iconos/arrow.svg';
import checkSVG from './Iconos/check.svg';
import ButtonSidebar3 from './ButtonSidebar/ButtonSidebar3';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

const PostPlanner = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const [isInstagramLoggedIn, setInstagramLoggedIn] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [publications, setPublications] = useState([]);
  const heading = t('step3Heading');
  const subtitle = t('step3Subtitle');
  const description = t('step3Description');

  const handlePreviousClick = () => {
    history.push('/Social-Networking2');
  };

  useEffect(() => {
    const fetchPublications = async () => {
      try {
        const token = localStorage.getItem('token');
        const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001'; // En desarrollo puedes usar localhost por defecto

        console.log(backendUrl);
        
        const response = await axios.get(`${backendUrl}/publications`, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        });
        setPublications(response.data);
      } catch (error) {
        console.error('Error fetching publications:', error);
        alert('Error fetching publications');
      }
    };

    fetchPublications();
  }, []);

  const handleDateChange = (year: number, month: number, day: number, hours: number, minutes: number) => {
    const newDate = new Date(year, month, day, hours, minutes);
    setSelectedDate(newDate);
  };

  const handleSchedulePost = async () => {
    console.log("Programar Publicación clicado"); // Log para depurar
    const url_imagen = localStorage.getItem('selectedImage');
    const textDataJSON = localStorage.getItem('textData');
    let generatedText = '';

    if (textDataJSON) {
      const textData = JSON.parse(textDataJSON);
      generatedText = textData.content;
    }

    if (!url_imagen || !generatedText) {
      alert('Por favor, genera una imagen y un texto antes de programar.');
      return;
    }

    const now = new Date();
    if (selectedDate <= now) {
      alert('Por favor, selecciona una fecha y hora futura.');
      return;
    }

    try {
      const token = localStorage.getItem('token');
      const date = selectedDate.toISOString();
      console.log('Fecha seleccionada:', date);
      const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001'; // En desarrollo puedes usar localhost por defecto

      console.log(backendUrl);
      
      await axios.post(`${backendUrl}/schedule-image-post`, {
        imageUrl: url_imagen,
        caption: generatedText,
        scheduleDate: date  // Envía la fecha formateada correctamente
      }, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      alert('Publicación programada con éxito');

      // Actualizar publicaciones
      const response = await axios.post(`${backendUrl}/publications`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });
      setPublications(response.data);
    } catch (error) {
      console.error('Error programando la publicación:', error);
    }
  };

  const handleNextClick = async () => {
    if (isInstagramLoggedIn) {
      const url_imagen = localStorage.getItem('selectedImage');
      const textDataJSON = localStorage.getItem('textData');
      let generatedText = '';
      const igAuth = localStorage.getItem('ig_auth');

      if (textDataJSON) {
        const textData = JSON.parse(textDataJSON);
        generatedText = textData.content;
      }

      if (!url_imagen || !generatedText) {
        alert('Por favor, genera una imagen y un texto antes de proceder.');
        return;
      }

      try {
        const token = localStorage.getItem('token');
        let response;

        const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001'; // En desarrollo puedes usar localhost por defecto

        console.log(backendUrl);

        response = await axios.post(`${backendUrl}/upload-to-instagram`, {
          imageUrl: url_imagen,
          caption: generatedText,
          igAuth
        }, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        history.push('/FinalScreen');
      } catch (error) {
        if (axios.isAxiosError(error)) {
          if (error.response) {
            console.error('Error response data:', error.response.data);
            console.error('Error response status:', error.response.status);
            console.error('Error response headers:', error.response.headers);
            alert(`Error al publicar en Instagram: ${error.response.data.message}`);
          } else if (error.request) {
            console.error('Error request:', error.request);
            alert('Error al publicar en Instagram: No se recibió respuesta del servidor.');
          }
        }
      }
    } else {
      alert('Por favor, inicia sesión en Instagram primero.');
    }
  };

  const handleInstagramLogin = async () => {
    try {
      const token = localStorage.getItem('token');
      const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001'; // En desarrollo puedes usar localhost por defecto

      console.log(backendUrl);
      const response = await axios.post(`${backendUrl}/login-instagram`, {}, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      if (response.status === 200) {
        setInstagramLoggedIn(true);
        alert('Iniciado sesión en Instagram con éxito');
      }
    } catch (error) {
      console.error('Error logging in to Instagram:', error);
      alert('Error al iniciar sesión en Instagram');
    }
  };

  const handleSaveDraft = async () => {
    const url_imagen = localStorage.getItem('selectedImage');
    const textDataJSON = localStorage.getItem('textData');
    let generatedText = '';

    if (textDataJSON) {
      const textData = JSON.parse(textDataJSON);
      generatedText = textData.content;
    }

    if (!url_imagen || !generatedText) {
      alert('Por favor, genera una imagen y un texto antes de guardar el borrador.');
      return;
    }

    try {
      const token = localStorage.getItem('token');
      const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001'; // En desarrollo puedes usar localhost por defecto

      console.log(backendUrl);
      await axios.post(`${backendUrl}/save-draft-final`, {
        url_imagen,
        generatedText
      }, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      alert('Borrador guardado con éxito');
    } catch (error) {
      console.error('Error guardando el borrador:', error);
    }
  };

  useEffect(() => {
    const userId = localStorage.getItem('userId');
    if (!userId) {
      history.push('/PantallaInicial');
    }
  }, [history]);

  return (
    <div className="componente-superior">
      <div className="columna-izquierda">
        <ImageSelection heading={heading} subtitle={subtitle} description={description} />
        <ChatBot />
      </div>
      <div className='central'>
        <PreviewScreen />
      </div>
      <div>
        <PublishSelection onInstagramLogin={handleInstagramLogin} />
        <SchedulePost
          selectedDate={selectedDate}
          onDateChange={(date) => handleDateChange(
            date.getFullYear(),
            date.getMonth(),
            date.getDate(),
            date.getHours(),
            date.getMinutes()
          )}
        />
        <Calendario
          selectedDate={selectedDate}
          onDateChange={(date) => handleDateChange(
            date.getFullYear(),
            date.getMonth(),
            date.getDate(),
            date.getHours(),
            date.getMinutes()
          )}
          publications={publications}
        />
        <button className="select-button" onClick={handleSchedulePost}>
          <div className='text-prompt-image'>
            <div className='text-prompt-icon'><img src={checkSVG} alt="" /></div>
            <div>{t('Programar Publicación')}</div>
          </div>
        </button>
        <div className="image-selection-navigation">
          <button className="image-selection-previous" onClick={handlePreviousClick}>
            <img src={arrowSVG} alt="" className='reverse-arrow' />{t('Anterior')}
          </button>
          <button className="image-selection-next" onClick={handleNextClick}>
            {t('Siguiente')} <img src={arrowSVG} alt="" className='normal-arrow' />
          </button>
        </div>
      </div>
      <ButtonSidebar3 onSaveDraft={handleSaveDraft} />
    </div>
  );
};

export default PostPlanner;
